module.exports = __webpack_public_path__ + "img/BannerNewMobile.f55462a3.svg";